
import {View} from 'backbone';
import template from 'dashboard/connections/details/connection-google-spreadsheets.ejs';
import restService from 'RestService';
import notificationService from 'NotificationService';
import constants from 'Constants.js';
import util from 'util/Util';
import Spinner              from 'spin/spin';
import loadScript from "load-script";

class ConnectionGoogleSpreadsheets extends View {
    initialize(opts){

        this.template = template;
        this.connectionService = opts.connectionService;

        this.events = {
            'change #fileName,#spreadSheet': 'processConnectionInputs',
            'click #getToken': 'getGoogleToken',
            'change #fileName' : 'getGoogleSheets',
            'click #checkAuth': 'connectAuthSub',
            'click #loadFilePicker': 'openGoogleFilePicker'
        };

        this.CLIENT_ID = '462091436683-uf7l839qomgs1oe4u8p5hudaskvo779d.apps.googleusercontent.com';
        this.API_KEY = 'AIzaSyD8y2t2chqibB1TG7SkVjIqE_PsxkQhZWg';
        this.APP_ID = '462091436683';
        this.GOOGLE_SDK_URL = "https://apis.google.com/js/api.js";

        this.firstLoad = true;

        this.listenTo(this.model, 'change', this.render);
        
        if(!this.model.get('files')){
           this.model.set('files', [], {silent: true});
        }

         if(!this.model.get('spreadSheets')){
           this.model.set('spreadSheets', [], {silent: true});
        }

        if(this.model.get('connectionDetails').ConnectionXML.Connection._id === ''){
            this.model.get('connectionDetails').ConnectionXML.Connection._id = this.model.get('connectionId');
        }

        if(!this.model.get('connectionDetails').ConnectionXML.Connection._fileName){
            this.model.get('connectionDetails').ConnectionXML.Connection._fileName = "";
        }

        window.currentModel = this;

        loadScript(this.GOOGLE_SDK_URL, ()=>{
            gapi.load('client:picker', ()=>{
                gapi.client.load('https://www.googleapis.com/discovery/v1/apis/drive/v3/rest');    
                this.pickerLoaded = true;            
            });
            
        });

        return this;
    }

    getGoogleTokens(){
        return  {
            accessToken: this.model.get('currentConnectionDetails').ConnectionXML.Connection._accessCode, 
            refreshToken: this.model.get('currentConnectionDetails').ConnectionXML.Connection._refreshCode
        };
    }


    connectAuthSub(){
         return this.connectionService.connectAuthSub(this.connectionService, arguments);
    }

    processConnectionInputs(ev){
        return this.connectionService.processConnectionInputs.apply(this.connectionService, arguments);
    }

    getGoogleToken(){
        const self = this;
        restService.getGoogleOAuth2URL().then((response)=>{
            self.redirectSignIn(response.Url['@value']);
        }).catch((err)=> {
            notificationService.error('Error Getting Google url, ' + (typeof(err) === 'string' ? err : (err.MESSAGE ? err.MESSAGE : 'Unknown Error')));
        });
    }

    checkUserAuthenticated(openPicker) {
        const self = this;
        const tokens = this.getGoogleTokens();

        if (tokens.accessToken && tokens.refreshToken) {
            restService.GoogleValidateOAuthCredential(tokens).then((response) => {
                if (util.isTrue(response.GoogleCredential['@isValid'])){
                    const accessToken = response.GoogleCredential['@accessToken'];
                    $('#loadFilePicker').prop('disabled', false);
                    self.model.get('currentConnectionDetails').ConnectionXML.Connection._status = "Connected";
                    self.model.get('currentConnectionDetails').ConnectionXML.Connection._accessCode = accessToken;

                    $('#googleConStatus').val('Connected');

                    const fileSelected = self.model.get('currentConnectionDetails').ConnectionXML.Connection._fileName && self.model.get('currentConnectionDetails').ConnectionXML.Connection._fileName !== "";
                    
                    if (!fileSelected && openPicker) {
                        self.openGoogleFilePicker();
                    }else if (fileSelected){
                        const fileId = self.model.get('currentConnectionDetails').ConnectionXML.Connection._fileId;
                        if (fileId && accessToken){
                            self.loadSheetsFromGoogle(tokens.refreshToken, accessToken, fileId);
                        }
                    }
                }
                else {
                    self.disconnectGoogleOAuth();
                    notificationService.error('Your Google credentials have expired. Please login again.');
                }

            }).catch((err) => {
                notificationService.error(err);
                console.log('Error: ', err);
            });
        }
    }

    disconnectGoogleOAuth(){
        this.model.get('currentConnectionDetails').ConnectionXML.Connection._status = "Not Connected";
        $('#googleConStatus').val('Not Connected');
        $('#loadFilePicker').prop('disabled', true);
    }

    validateOAuthCode(code){
        const self = this;
        if (code && code != "") {
            restService.GoogleValidateOAuthCode(code).then((response) => {
                const accessToken = response.AuthenticationInfo["@access_token"];
                const refreshToken = response.AuthenticationInfo["@refresh_token"];
                const email = response.AuthenticationInfo["@email"];

                self.model.get('currentConnectionDetails').ConnectionXML.Connection._username = email;   
                self.model.get('currentConnectionDetails').ConnectionXML.Connection._refreshCode = refreshToken;
                self.model.get('currentConnectionDetails').ConnectionXML.Connection._accessCode = accessToken;
                 
                $("#googleAccount").val(email);
                $('#loadFilePicker').prop('disabled', false);
                self.model.set('hasChanges', true);
                self.checkUserAuthenticated(true);
            }).catch((err) => {
                self.disconnectGoogleOAuth();
                const _errorMsg = 'Error: ' + (typeof(err) === 'string' ? err : (err.MESSAGE ? err.MESSAGE : 'Unknown Error'));
                notificationService.error(_errorMsg);
                console.log(_errorMsg);
            });
        }
    }

    authenticateGoogle(event){
        const self = window.currentModel;
        try {
            const code = event.data[0].code;
            self.validateOAuthCode(code);
            $(constants.LOADING).hide();
        }
        catch (err) {
            console.log(err);
            $(constants.LOADING).hide();
        }       
    }

    redirectSignIn(signInURL) {

        const spinner = $(constants.LOADING);
        spinner.find('h4').text('Authenticating user... \n Please finish the authentication process in the popup window.');
        spinner.show();
   
        window.removeEventListener("message", this.authenticateGoogle, true);
        window.addEventListener("message", this.authenticateGoogle, true);
   
        setTimeout(() => {
            
            const popup = util.popupWindow(signInURL, window, 550, 700);

            const checkPopup = setInterval(() => {
                if (!popup) {
                    window.alert(constants.POPUP_BLOCKER_MESSAGE);
                    spinner.hide(); 
                    clearInterval(checkPopup);               
                }
                else if(popup.closed){
                    spinner.hide(); 
                    clearInterval(checkPopup);       
                }

            }, 400);
        }, 200);
    }


    openGoogleFilePicker(){
        const tokens = this.getGoogleTokens();
       
        if (this.pickerLoaded && tokens.accessToken) {           
            
            const view = new google.picker.DocsView()
              .setMode(google.picker.DocsViewMode.LIST)
              .setIncludeFolders(true)
              .setMimeTypes("application/vnd.google-apps.spreadsheet, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
              .setOwnedByMe(true);
            const picker = new google.picker.PickerBuilder()
              .enableFeature(google.picker.Feature.NAV_HIDDEN)
              .setAppId(this.APP_ID)
              .setOAuthToken(tokens.accessToken)
              .addView(view)
              .setDeveloperKey(this.API_KEY)
              .setCallback(this.getGoogleSheets)
              .build();
            picker.setVisible(true);
          }

    }

    getGoogleSheets(data){
        const self = window.currentModel;

        if (data[google.picker.Response.ACTION] == google.picker.Action.PICKED) {
            const tokens = self.getGoogleTokens();
            let doc = data[google.picker.Response.DOCUMENTS][0];
            
            const fileId = doc.id;
            self.model.get('currentConnectionDetails').ConnectionXML.Connection._fileId = fileId;   
            self.model.get('currentConnectionDetails').ConnectionXML.Connection._fileName = doc.name;   
            self.model.set('hasChanges', true, { silent: true });
            self.loadSheetsFromGoogle(tokens.refreshToken, tokens.accessToken, fileId);
        }
    }

    loadSheetsFromGoogle(accessToken, refreshToken, fileId){
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        const self = window.currentModel;
        restService.GetSheetsOAuth2(refreshToken, accessToken, fileId).then((response)=>{
            let sheets = util.enforceArrayType(response.Sheets.Sheet);
            _.orderBy(sheets, ['@name'], ['asc']);
            self.model.set('spreadSheets', sheets, { silent: true });
            self.model.trigger('change');

            const spreadSheet = self.model.get('currentConnectionDetails').ConnectionXML.Connection['_spreadsheet'];

            if(spreadSheet !== ""){
                $("#spreadSheet").val(spreadSheet);
            }

            $('#spreadSheet').prop('disabled',false);
        }).catch((err)=> {
            notificationService.error('Error Getting Sheets ' + err);
        }).finally(() => {
            spinner.stop();
        });
    }
    
    render(){
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if(this.firstLoad){
            setTimeout(() => { //Wait for the actions service to finish
                this.checkUserAuthenticated();
            }, 500);
            this.firstLoad = false;
        }

        if(this.model.get('currentConnectionDetails').ConnectionXML.Connection._fileName) {
            $('#fileName').find("option[value='"+this.model.get('currentConnectionDetails').ConnectionXML.Connection._fileId+"']").attr('selected', true);
        }

        if (!this.model.get('currentConnectionDetails').ConnectionXML.Connection._spreadsheet){
            let sheets = this.model.get('spreadSheets');
            if (sheets && sheets.length > 0){
                this.model.get('currentConnectionDetails').ConnectionXML.Connection._spreadsheet = sheets[0]['@name'];
            }

        }

        this.delegateEvents();
        return this;
    }

}

export default ConnectionGoogleSpreadsheets;